// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"60b218fc","511":"d761478f"}[chunkId] + ".chunk.js";
};